import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Trésorerie ESS et économie sociale : gérer les fonds publics et privés | Trezoone',
    description: 'Structures de l\'ESS : associations, SCOP, mutuelles, fondations. Gérez votre trésorerie avec les enjeux spécifiques aux fonds mixtes publics/privés.',
    canonical: '/tresorerie-ess-economie-sociale',
    keywords: 'trésorerie ESS, économie sociale et solidaire trésorerie, trésorerie SCOP, trésorerie fondation, gestion financière ESS',
  },
  hero: {
    tag: 'Trésorerie ESS',
    title: 'Financement mixte public/privé, multiples financeurs, reporting exigeant : la trésorerie ESS a ses propres règles.',
    subtitle: 'Les structures de l\'économie sociale et solidaire ont des contraintes financières spécifiques. Trezoone les comprend.',
    ctaLabel: 'Adapter Trezoone à ma structure',
  },
  pilierLink: { label: 'Gestion trésorerie association', href: '/gestion-tresorerie-association' },
  sections: [
    {
      type: 'explain',
      title: 'Les spécificités financières des structures ESS',
      content: 'Les structures ESS (associations, SCOP, SCIC, fondations) ont des modèles financiers complexes :',
      items: [
        'Mix de financements : subventions publiques + financements privés + recettes d\'activité',
        'Contraintes d\'affectation : certains fonds ne peuvent être utilisés que pour des projets précis',
        'Reporting multiple : chaque financeur a ses propres exigences de compte-rendu',
        'Délais de versement longs : les financements publics sont systématiquement décalés',
        'Réserves légales : constitution obligatoire de réserves selon les statuts',
      ],
    },
    {
      type: 'midcta',
      title: 'Financement mixte, multiples financeurs, reporting exigeant — gérez tout dans un seul outil',
      content: 'Trezoone est conçu pour les structures ESS : suivi par projet, alertes sur les versements attendus, rapports adaptés aux financeurs publics et privés.',
    },
    {
      type: 'solution',
      title: 'Trezoone pour les structures ESS',
      content: 'Un outil qui comprend les réalités du financement mixte et des contraintes ESS.',
      items: [
        'Suivi des financements par source et par projet',
        'Alertes sur les versements attendus (subventions, aides, dotations)',
        'Plan de trésorerie intégrant les cycles de financement public',
        'Rapports adaptés aux exigences des financeurs publics et privés',
        'Gestion multi-comptes (fonctionnement, projets, réserves)',
      ],
    },
    {
      type: 'cluster',
      title: 'Ressources pour les structures de l\'économie sociale',
      links: [
        { label: 'Logiciel trésorerie association', href: '/logiciel-tresorerie-association' },
        { label: 'Subvention en retard', href: '/subvention-en-retard-tresorerie' },
        { label: 'Trésorerie association loi 1901', href: '/tresorerie-association-loi-1901' },
        { label: 'Reporting financier association', href: '/reporting-financier-association' },
        { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
        { label: 'Stress test trésorerie', href: '/stress-test-tresorerie' },
      ],
    },
    {
      type: 'cta',
      title: 'Simplifiez la gestion financière de votre structure ESS',
      content: 'Trezoone s\'adapte à vos contraintes. Essai gratuit 14 jours.',
    },
  ],
  relatedLinks: [
    { label: 'Logiciel trésorerie association', href: '/logiciel-tresorerie-association' },
    { label: 'Subvention en retard', href: '/subvention-en-retard-tresorerie' },
    { label: 'Trésorerie association loi 1901', href: '/tresorerie-association-loi-1901' },
    { label: 'Reporting financier association', href: '/reporting-financier-association' },
    { label: 'Simulation trésorerie association', href: '/simulation-tresorerie-association' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
    { label: 'Stress test trésorerie', href: '/stress-test-tresorerie' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function TresorerieEssSocialPage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
